import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import toast, { Toaster } from "react-hot-toast";
import CostCenterService from "../../../../services/OrderingServices/CostCenterService";

export const PrintBill = ({
  currentOrder,
  totalDiscount,
  calculateTotals,
  orderId,
  user,
  selectedCustomer,
  responseData,
  isestimateprint,
}) => {
  console.log("🚀 ~ PrintBill ~ selectedCustomer:", selectedCustomer);
  const socketRef = useRef(null);
  const [connectionStatus, setConnectionStatus] = useState("disconnected");
  const [userInfo, setUserInfo] = useState(null);
  console.log("🚀 ~ PrintBill ~ userInfo:", userInfo);
  const [webSocketUrl, setWebSocketUrl] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [costCenterData, setCostCenterData] = useState(null);

  const fetchCostCenter = async () => {
    try {
      const response = await CostCenterService.getList();
      const actualData = Array.isArray(response)
        ? response
        : response?.data || [];

      const billPrinter = actualData.find(
        (item) => item.name?.trim().toLowerCase() === "bill printer"
      );
      setCostCenterData(billPrinter || null);
    } catch (error) {
      console.error("❌ Fetch cost center error:", error);
    }
  };

  useEffect(() => {
    fetchCostCenter();
  }, []);

  useEffect(() => {
    if (!costCenterData?.printerPort) return;

    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
      const dynamicWebSocketUrl = `ws://localhost:${costCenterData.printerPort}`;
      setWebSocketUrl(dynamicWebSocketUrl);
    }
  }, [costCenterData]);

  useEffect(() => {
    if (!webSocketUrl) return;

    const connectWebSocket = () => {
      setConnectionStatus("connecting");
      socketRef.current = new WebSocket(webSocketUrl);

      socketRef.current.onopen = () => {
        console.log("WebSocket connection established");
        setConnectionStatus("connected");
      };

      socketRef.current.onclose = () => {
        console.log("WebSocket connection closed");
        setConnectionStatus("disconnected");
      };

      socketRef.current.onerror = (error) => {
        console.error("WebSocket error:", error);
        setConnectionStatus("error");
        toast.error("Connection error. Please refresh or try again later.", {
          duration: 4000,
          position: "top-right",
          style: {
            background: "#fee2e2",
            color: "#b91c1c",
          },
        });
      };

      socketRef.current.onmessage = (event) => {
        try {
          const response = JSON.parse(event.data);
          if (response.status === "success") {
            toast.success(response.message || "Bill printed successfully", {
              duration: 4000,
              position: "top-right",
              style: {
                background: "#dcfce7",
                color: "#166534",
              },
            });
          }
        } catch (error) {
          console.error("Error parsing WebSocket response:", error);
        } finally {
          setIsPrinting(false);
        }
      };
    };

    connectWebSocket();

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [webSocketUrl]);

  const handlePrintBill = () => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      setIsPrinting(true);

      const itemsList =
        responseData?.orderSummary?.orderDetails || responseData?.items || [];

      const formattedItems = itemsList.map((item) => {
        const quantity = item.finalQuantity ?? item.quantity ?? 0;
        const unitPrice = Number(item.price ?? item.productPrice ?? 0);
        const totalPrice = unitPrice * quantity;

        return {
          itemName: item.name || item.productName,
          quantity,
          unitPrice,
          totalPrice,
          isComplimentary: item.isComplimentary || false,
        };
      });

      const totals =
        typeof calculateTotals === "function"
          ? calculateTotals()
          : {
              subTotal: responseData?.totalAmount ?? 0,
              total: responseData?.grandTotal ?? 0,
            };
      const billData = {
        cafeName: userInfo?.organizationInfo?.name,
        location: userInfo?.organizationInfo?.address1,
        pan: userInfo?.organizationInfo?.panNumber,
        phone: userInfo?.organizationInfo?.tel,
        billprintedby: userInfo?.userName,
        type: "PRINT_BILL",
        items: formattedItems,
        subTotal: Number(totals?.subTotal) || 0,
        netAmount: Number(totals?.total) || 0,
        salesInvoiceNumber:
          responseData?.invoiceNumber || responseData?.orderRefrenceId,
        message: `Thank you for visiting ${userInfo?.organizationInfo?.name}!`,
        isestimateprint: isestimateprint,
      };

      // Add customer fields only if they exist
      if (selectedCustomer?.firstName || selectedCustomer?.lastName) {
        billData.customername = `${selectedCustomer?.firstName || ""} ${
          selectedCustomer?.lastName || ""
        }`.trim();
      }

      if (selectedCustomer?.phoneNo) {
        billData.customerphone = selectedCustomer.phoneNo;
      }

      if (selectedCustomer?.address) {
        billData.customeraddress = selectedCustomer.address;
      }

      if (totalDiscount) {
        billData.discount = Math.round(totalDiscount);
      } else if (responseData?.discountAmount) {
        billData.discount = Number(responseData.discountAmount);
      }

      socketRef.current.send(JSON.stringify(billData));
    } else {
      console.error("WebSocket not connected");
      setConnectionStatus("error");
      toast.error("WebSocket not connected. Please try again.", {
        duration: 4000,
        position: "top-right",
        style: {
          background: "#fee2e2",
          color: "#b91c1c",
        },
      });
    }
  };

  return (
    <div>
      <Toaster />
      <button
        className="btn btn-soft-success"
        title="Print"
        onClick={handlePrintBill}
        disabled={!webSocketUrl || isPrinting}
      >
        {isPrinting ? (
          "Printing..."
        ) : connectionStatus === "connecting" ? (
          "Connecting..."
        ) : (
          <i className="bx bx-printer"></i>
        )}
      </button>
    </div>
  );
};
